import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/DisabilityConfirmations';

export interface IDisabilityConfirmation {
  title: string;
  displayTitle: string;
  description: string;
  attachmentId: number;
  disabilityName: string;
  linkInformation: string;
  link: string;
  isEnglish: boolean;
  englishAttachmentId: number;
  additionalDescription?: string;
  additionalTitle?: string;
}

export interface IFile {
  id: number;
  file: string;
}

export interface IEligibleFamilyMember {
  id: number;
  identityNumber: string;
  firstName: string;
  lastName: string;
}

export const getDisabilityConfirmations = async () => {
  const paymentAndDeductions = await api.get<IDisabilityConfirmation[]>(
    addImposterToUrl(`${baseURL}`, true)
  );
  if (paymentAndDeductions.data) return paymentAndDeductions.data;
};

export const getDisabilityConfirmationPdf = async (id: number) => {
  const disabilityConfirmationPdf = await api.get<IFile>(
    addImposterToUrl(`${baseURL}/${id}`, true)
  );
  if (disabilityConfirmationPdf.data) return disabilityConfirmationPdf.data;
};

export const getEligibleFamilyMembers = async () => {
  const eligibleFamilyMembers = await api.get<IEligibleFamilyMember[]>(
    addImposterToUrl(`${baseURL}/FamilyMembers`, true)
  );
  if (eligibleFamilyMembers?.data) return eligibleFamilyMembers.data;
};

export const getFamilyMembersConfirmationPdf = async (
  identityNumber: string
) => {
  const eligibleFamilyMembers = await api.get<IFile>(
    addImposterToUrl(`${baseURL}/HaravotBarzel?familyMemberId=${identityNumber}`, false)
  );
  if (eligibleFamilyMembers?.data) return eligibleFamilyMembers.data;
};
